import { useToast, type Toast } from "@/hooks/useToast";

const iconMap: Record<Toast["type"], string> = {
  success: "ri-checkbox-circle-line",
  error: "ri-close-circle-line",
  info: "ri-information-line",
  warning: "ri-alert-line",
};

const bgMap: Record<Toast["type"], string> = {
  success: "border-emerald-200 bg-emerald-50",
  error: "border-red-200 bg-red-50",
  info: "border-gray-200 bg-white",
  warning: "border-amber-200 bg-amber-50",
};

const iconColorMap: Record<Toast["type"], string> = {
  success: "text-emerald-600",
  error: "text-red-500",
  info: "text-gray-600",
  warning: "text-amber-600",
};

const textColorMap: Record<Toast["type"], string> = {
  success: "text-emerald-800",
  error: "text-red-700",
  info: "text-gray-700",
  warning: "text-amber-800",
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-6 right-6 z-[9999] flex flex-col gap-3 max-w-sm w-full pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`pointer-events-auto flex items-start gap-3 p-4 rounded-xl border shadow-lg backdrop-blur-sm animate-slide-in-right ${bgMap[toast.type]}`}
          style={{
            animation: "slideInRight 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards",
          }}
        >
          <div className={`flex-shrink-0 pt-0.5 ${iconColorMap[toast.type]}`}>
            <i className={`${iconMap[toast.type]} text-lg`} />
          </div>
          <p className={`text-sm font-medium flex-1 ${textColorMap[toast.type]}`}>
            {toast.message}
          </p>
          <button
            onClick={() => removeToast(toast.id)}
            className={`flex-shrink-0 cursor-pointer ${iconColorMap[toast.type]} hover:opacity-70 transition-opacity`}
          >
            <i className="ri-close-line text-base" />
          </button>
        </div>
      ))}
    </div>
  );
}